import axios from 'axios';

// REACT_APP_BACKEND_URL vacío → baseURL relativa "/api" (mismo origen, vía nginx).
// Robusto ante cambios de dominio y evita hornear localhost en el build de prod.
// El `|| ''` impide que un env sin definir produzca "undefined/api".
const api = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL || ''}/api`,
  withCredentials: true,
});

// Si la sesión expira a media navegación, redirigir al login en vez
// de dejar que las páginas muestren toasts de "Error cargando…".
// Excepción: las llamadas a /auth/* no redirigen — el login mismo
// hace POST /auth/login y un 401 ahí es "credenciales malas", no
// "sesión expirada".
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error?.response?.status === 401) {
      const url = error?.config?.url || "";
      const isAuthEndpoint = url.startsWith("/auth/");
      const onLoginPage = window.location.pathname === "/login";
      if (!isAuthEndpoint && !onLoginPage) {
        window.location.assign("/login");
      }
    }
    return Promise.reject(error);
  }
);

export default api;
